import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateSectorModal, EditSectorModal, SectorsListFilters } from "@modules/bookSectors/components";

import { useBookSectors } from "./controller";
import { useBookSectorsListColumns } from "./columns";

export const BookSectorList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createSectorModalRef,
    editSectorModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useBookSectors();

  const columns = useBookSectorsListColumns(refetch, translate, editSectorModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <SectorsListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="book-sectors.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createSectorModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateSectorModal
        modalRef={createSectorModalRef}
        onComplete={refetch}
      />

      <EditSectorModal
        modalRef={editSectorModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
